/* jshint browserify: true */
'use strict';

import mathRendererFactory from './mathRendererFactory';
import ElementsMath from './elementsMath';
import constants from './constants';

const math = {
    constants,
    elementsMath(rendererType) {
        return new ElementsMath(mathRendererFactory.create(rendererType));
    },
};

export default math;